document.addEventListener('DOMContentLoaded', function() {
  if (window.localStorage.getItem('scrollToProducts') === 'true') {
    // Target the sticky bar, not the grid itself
    var stickyUtils = document.querySelector('.productgrid--utils-sticky');
    if (stickyUtils) {
      // Compute offset for any announcement/header above sticky bar
      let offset = 0;

      // Use actual selectors found in your repo
      var announcement = document.querySelector('.announcement-bar');
      if (announcement) offset += announcement.offsetHeight;

      var header = document.querySelector('.site-header');
      if (header) offset += header.offsetHeight;

      // Now scroll sticky bar to top of viewport
      var stickyTop = stickyUtils.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: stickyTop, behavior: 'smooth' });
    }
    window.localStorage.removeItem('scrollToProducts');
  }

  document.querySelectorAll('.pagination--inner a').forEach(function(link) {
    link.addEventListener('click', function() {
      window.localStorage.setItem('scrollToProducts', 'true');
    });
  });
});